import React from 'react'
import _ from 'lodash/fp'
import localStore from 'localforage'
import { connect } from 'react-redux'
import * as AuthReducer from '../../reducers/auth'

import { TOKEN_KEY } from '../../sagas/auth'

const AutoLogin = props => {
  const searchParams = new URLSearchParams(_.get('location.search', props))
  const redirect = searchParams.get('rd')
  const token = searchParams.get('token')

  React.useEffect(() => {
    if (token && props.notBootstrapped) {
      localStore.setItem(TOKEN_KEY, { token })
        .then(() => props.bootstrap())
    } else {
      props.history.replace(redirect)
    }
  }, [props.notBootstrapped])

  return false
}

export default _.compose(
  connect(
    s => ({
      notBootstrapped: AuthReducer.selectors.notBootstrapped(s)
    }),
    d => {
      return {
        bootstrap: () => d(AuthReducer.actions.bootstrapRequest(Date.now()))
      }
    }
  )
)(AutoLogin)
